import { createStyles } from '@mantine/core';

// TODO: RESPONSIVE styles for mobile
const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    maxWidth: '420px',
    gap: theme.other.spacing._24,
    padding: '24px 16px',
    [`@media(max-width: ${theme.breakpoints.sm}px)`]: {
      paddingTop: 0,
      gap: theme.other.spacing._12,
    },
  },
  titleContainer: {
    display: 'flex',
  },
  buttonsContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    width: '100%',
  },
  formContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    width: '100%',
    marginTop: '-22px',

    [`@media(max-width: ${theme.breakpoints.sm}px)`]: {
      marginTop: '-64px',
    },
  },
  textWithLink: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonLink: {
    fontSize: 14,
    fontWeight: 600,
    marginLeft: theme.other.spacing._8,
    lineHeight: '22px',
  },
  forgotPasswordLink: {
    alignSelf: 'center',
    paddingBottom: theme.other.spacing._12,
    textAlign: 'center',
    marginLeft: 0,
  },
  emailOrUsernameInfo: {
    paddingLeft: theme.other.spacing._8,
    paddingRight: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
  },
  divider: {
    width: '100%',
    paddingTop: theme.other.spacing._2,
    paddingBottom: theme.other.spacing._24,
    alignSelf: 'center',
    paddingLeft: 4,
    paddingRight: 4,
    [`@media(max-width: ${theme.breakpoints.sm}px)`]: {
      paddingBottom: theme.other.spacing._12,
    },
  },
  ssoLink: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 1,
  },
  ssoButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.other.spacing._24,
    paddingTop: theme.other.spacing._48,
    justifyContent: 'center',
    textAlign: 'center',
    [`@media(max-width: ${theme.breakpoints.sm}px)`]: {
      paddingBottom: theme.other.spacing._64,
      paddingTop: theme.other.spacing._12,
      gap: theme.other.spacing._12,
    },
  },
  ssoButtonHeader: {
    paddingBottom: theme.other.spacing._12,
  },
}));

export default useStyles;
